"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusToNextPlanInfo = exports.statusToNextPlan = exports.statusToAccountInfoMap = exports.ADMIN_RECIPE_LIMIT = exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT = exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT = exports.FREE_RECIPE_LIMIT = exports.statusToPlanId = exports.statusToRecipeLimitReachedAction = exports.statusToConfirmUpgradeMessage = exports.UPGRADE_TO_SEASONED_COOK_OPERATION = exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID = exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID = exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID = exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID = exports.PADDLE_HOME_COOK_OG_YEARLY_PLAN_ID = exports.PADDLE_HOME_COOK_OG_PLAN_ID = exports.ADMIN_PLAN_NAME = exports.SEASONED_PLAN_NAME = exports.STANDARD_PLAN_NAME = exports.FREE_PLAN_NAME = exports.CUSTOM_STATUS = exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS = exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS = exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS = exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS = exports.SEASONED_SUBSCRIPTION_STATUS = exports.STANDARD_SUBSCRIPTION_STATUS = exports.BETA_STATUS = exports.FREE_STATUS = exports.ADMIN_STATUS = void 0;
exports.ADMIN_STATUS = "admin";
exports.FREE_STATUS = "free";
exports.BETA_STATUS = "beta";
exports.STANDARD_SUBSCRIPTION_STATUS = "standard-subscription";
exports.SEASONED_SUBSCRIPTION_STATUS = "seasoned-subscription";
exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS = "standard-subscription-cancelled";
exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS = "standard-subscription-expired";
exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS = "seasoned-subscription-cancelled";
exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS = "seasoned-subscription-expired";
exports.CUSTOM_STATUS = "custom";
exports.FREE_PLAN_NAME = "Budding Cook";
exports.STANDARD_PLAN_NAME = "Home Cook";
exports.SEASONED_PLAN_NAME = "Seasoned Cook";
exports.ADMIN_PLAN_NAME = "Admin";
exports.PADDLE_HOME_COOK_OG_PLAN_ID = "571836";
exports.PADDLE_HOME_COOK_OG_YEARLY_PLAN_ID = "581100";
exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID = "587330";
exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID = "587329";
exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID = "580984";
exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID = "587328";
exports.UPGRADE_TO_SEASONED_COOK_OPERATION = "upgrade-to-seasoned-cook";
exports.statusToConfirmUpgradeMessage = (status) => {
    const nextPlan = exports.statusToNextPlanInfo[status];
    if (nextPlan.key === "custom") {
        return `I wasn't expecting anyone to add this many recipes, nice job! Send me an email at ben@mysaffronapp.com and I can help increase your limit.`;
    }
    return `Would you like to upgrade to the ${nextPlan.name} plan? For $${nextPlan.cost}/month you'll be able to add up to ${nextPlan.recipeLimit.toLocaleString()} recipes`;
};
exports.statusToRecipeLimitReachedAction = {
    [exports.FREE_STATUS]: "buy-home-cook",
    [exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]: "buy-home-cook",
    [exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]: "buy-home-cook",
    [exports.SEASONED_SUBSCRIPTION_STATUS]: "send-email",
    [exports.BETA_STATUS]: "buy-seasoned-cook",
    [exports.STANDARD_SUBSCRIPTION_STATUS]: "swap-plan-to-seasoned-cook",
    [exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]: "buy-seasoned-cook",
    [exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]: "buy-seasoned-cook",
    [exports.ADMIN_STATUS]: "send-email",
    [exports.CUSTOM_STATUS]: "send-email",
};
exports.statusToPlanId = (status, yearly = true) => {
    if (status === "seasoned-subscription" && yearly) {
        return exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID;
    }
    else if (status === "seasoned-subscription") {
        return exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID;
    }
    else if (status === "standard-subscription" && yearly) {
        return exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID;
    }
    else if (status === "standard-subscription") {
        return exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID;
    }
    return "";
};
exports.FREE_RECIPE_LIMIT = 50;
exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT = 1000;
exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT = 5000;
exports.ADMIN_RECIPE_LIMIT = 10000;
exports.statusToAccountInfoMap = {
    free: {
        key: "free",
        name: "Budding Cook",
        recipeLimit: exports.FREE_RECIPE_LIMIT,
    },
    beta: {
        key: "beta",
        name: "Home Cook",
        recipeLimit: exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT,
    },
    ["standard-subscription"]: {
        key: "standard-subscription",
        name: "Home Cook",
        recipeLimit: exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT,
        monthlyCheckoutId: exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID,
        yearlyCheckoutId: exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID,
        cost: 5,
    },
    ["seasoned-subscription"]: {
        key: "seasoned-subscription",
        name: "Seasoned Cook",
        recipeLimit: exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT,
        monthlyCheckoutId: exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID,
        yearlyCheckoutId: exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID,
        cost: 10,
    },
    ["standard-subscription-cancelled"]: {
        key: "standard-subscription-cancelled",
        name: "Home Cook",
        recipeLimit: exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT,
    },
    ["seasoned-subscription-cancelled"]: {
        key: "seasoned-subscription-cancelled",
        name: "Seasoned Cook",
        recipeLimit: exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT,
    },
    ["standard-subscription-expired"]: {
        key: "standard-subscription-expired",
        name: "Home Cook",
        recipeLimit: exports.FREE_RECIPE_LIMIT,
    },
    ["seasoned-subscription-expired"]: {
        key: "seasoned-subscription-expired",
        name: "Seasoned Cook",
        recipeLimit: exports.FREE_RECIPE_LIMIT,
    },
    admin: {
        key: "admin",
        name: "Admin",
        recipeLimit: exports.ADMIN_RECIPE_LIMIT,
    },
    custom: {
        key: "custom",
        name: "Custom",
        recipeLimit: exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT,
    },
};
exports.statusToNextPlan = {
    [exports.FREE_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.SEASONED_SUBSCRIPTION_STATUS]: exports.CUSTOM_STATUS,
    [exports.BETA_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.STANDARD_SUBSCRIPTION_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.ADMIN_STATUS]: exports.CUSTOM_STATUS,
    [exports.CUSTOM_STATUS]: exports.CUSTOM_STATUS,
};
exports.statusToNextPlanInfo = {
    [exports.FREE_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.FREE_STATUS]],
    [exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]],
    [exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]],
    [exports.SEASONED_SUBSCRIPTION_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.SEASONED_SUBSCRIPTION_STATUS]],
    [exports.BETA_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.BETA_STATUS]],
    [exports.STANDARD_SUBSCRIPTION_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.STANDARD_SUBSCRIPTION_STATUS]],
    [exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]],
    [exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]],
    [exports.ADMIN_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.ADMIN_STATUS]],
    [exports.CUSTOM_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.CUSTOM_STATUS]],
};
//# sourceMappingURL=account.js.map